import React, { useEffect, useLayoutEffect, useState } from 'react';
import { connect, useStore } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import useMedia from 'use-media';
import { useRtoaster } from '../../../hooks/useRtoaster';
import { apiKeyCheck } from '../../../const';
import image_complete from '../../../resources/icons/complete.svg';
import image_base from '../../../resources/image/HakoneGardenTerrace.jpg';
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import './../../../resources_membership_hotel/css/hotel/membership_reserve_comp.css';
import { MembershipFooterContainer } from './../common/membershipFooterContainer';

const ReserveCompleteContainer = (props) => {
    const {
        inputUserInfo,
        setInputUserInfo,
        membershipReserveComf,
        membershipReserveInfo,
        setMembershipReserveComf,
        mealInfoList,
        setMealInfoList,
        setOtherMenuInfoList,
        membershipSearchParam,
        setMembershipSearchParam,
        setMembershipReserveInfo,
        setInputRoomList,
        setRight,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    const [inputAcconpanyFlg, setInputAcconpanyFlg] = useState(false)
    const [reserveComf, setReserveComf] = useState({})
    const [changeFlg, setChangeFlg] = useState(false)
    const [machiPlanCheckDispFlg, setMachiPlanCheckDispFlg] = useState(false)

    const login = store.getState().login;
    const loginType = login.loginType;

    // rtoasterタグ生成
    const customParam = {
        "riyosyodat": membershipSearchParam.checkInDate,
        "sisetucd": membershipReserveInfo.shisetsuCd,
        "packcd": membershipReserveInfo.planCd,
        "packnam": membershipReserveInfo.planName,
        "keiyakuno": membershipSearchParam.keiyakuNo,
        "restaurantcd2": mealInfoList?.filter(value => value.jikantaiKbn == "2")?.map(value => value.restaurantCd)?.join(","),
        "restaurantcd3": mealInfoList?.filter(value => value.jikantaiKbn == "3")?.map(value => value.restaurantCd)?.join(","),
        "hakusu": membershipSearchParam.nights,
        "nonstopcheckinflg": inputUserInfo.smartCheckInFlg,
        "nonstopcheckoutflg": inputUserInfo.smartCheckOutFlg,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        window.scroll({ top: 0, behavior: 'smooth' })
        if (Object.keys(membershipReserveComf).length != 0) {
            setReserveComf(membershipReserveComf);
        }
        if (Object.keys(inputUserInfo).length != 0) {
            setInputAcconpanyFlg(inputUserInfo.inputAcconpanyFlg);
            setMachiPlanCheckDispFlg(inputUserInfo.machiPlanCheckDispFlg);
        }
        setChangeFlg(membershipReserveInfo.changeFlg)
        // setInputUserInfo({});
        setMembershipReserveComf({});
        setMealInfoList([]);
        setOtherMenuInfoList([]);
        setMembershipReserveInfo({});
        setMembershipSearchParam({});
        setInputRoomList([]);
        setRight([]);
    }, []);

    //yyyy-mm-ddをyyyy年mm月dd日(曜日)形式に変換
    const dateForm = (res) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        var dateArr = res.split("-")
        let date = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
        let convert = dateArr[0] + "年" + dateArr[1].replace(/^0+/, '') + "月" + dateArr[2].replace(/^0+/, '') + "日" + "(" + youbi[date.getDay()] + ")";

        return convert;
    }

    const onClickInputAccompany = () => {
        let newReserveComf = {...reserveComf};
        newReserveComf.pageKbn = "membershipResvComp";
        setMembershipReserveComf(newReserveComf);
        history.push("/reserve/hotel/inputAccompany")
    }
    const deleteReserveConf = () => {
        setInputUserInfo({});
        history.push(loginType === "MEMBER" ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch")
    }

    return (
        <div style={isWideTablet ? styles.topCancel : styles.top}>
            <div className={isWideTablet ? "membership_reserve_base4" : "membership_reserve_base3"}>
                <div style={styles.complete}></div>
                <p className="membership_reserve_title">{(inputUserInfo.machiMongon? 
                inputUserInfo.machiMongon.indexOf('一部') !== -1 ? "一部" : "" : "" )+ (reserveComf.machiFlg === "1" ? "交換待ちで" : reserveComf.machiFlg === "2" ? "キャンセル待ちで" : changeFlg ? "ご予約の変更を" : "ご予約を")}承りました</p>
                <p className={isWideTablet ? "membership_reserve_text2" : "membership_reserve_text"}>
                    ご利用いただき誠にありがとうございます。
                    <br />予約完了メールをお送りいたしましたので、{isWideTablet ? <br /> : null}内容をご確認ください。
                </p>
                <div className='membership_reserveinfo_area'>
                    <div className='membership_reserveinfo_content'>
                        <div className='membership_reserveinfo_title'>
                            <div>ご予約内容</div>
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className="reserveInfoContentBlock">
                                <div className='reservationContent lastContent'>
                                    <div className='reserveInfoTitleGray block'>予約番号</div>
                                    <div className='membership_reserve_cancel_info block'>{reserveComf.yoyakuNo}</div>
                                </div>
                            </div>
                            <div className="reserveInfoContentBlock">
                                <div className='reservationContent lastContent'>
                                    <div className='reserveInfoTitleGray block'>ホテル名</div>
                                    <div className='membership_reserve_cancel_info block'>{reserveComf.shisetsuName}</div>
                                </div>
                            </div>
                            <div className="reserveInfoContentBlock">
                                <div className='reservationContent lastContent'>
                                    <div className='reserveInfoTitleGray'>チェックイン</div>
                                    <div className='membership_reserve_cancel_info'>{reserveComf.checkInDate ? dateForm(reserveComf.checkInDate) : ""}</div>
                                </div>
                                <div className='reservationContent lastContent'>
                                    <div className='reserveInfoTitleGray'>チェックアウト</div>
                                    <div className='membership_reserve_cancel_info'>{reserveComf.checkOutDate ? dateForm(reserveComf.checkOutDate) : ""}</div>
                                </div>
                                <div className='reservationContent lastContent'>
                                    <div className='reserveInfoTitleGray block'></div>
                                    <div className='membership_reserve_cancel_info'>{reserveComf.hakuCnt}泊</div>
                                </div>
                            </div>
                            <div className="reserveInfoContentBlock">
                                <div className='reservationContent lastContent'>
                                    <div className='reserveInfoTitleGray block'>室数</div>
                                    <div className='membership_reserve_cancel_info block'>{reserveComf.roomCnt}室</div>
                                </div>
                            </div>
                            <div className="reserveInfoContentBlock">
                                <div className='reservationContent lastContent'>
                                    <div className={"reserveInfoTitleGray block"}>宿泊プラン名</div>
                                    <div className='membership_reserve_cancel_info block'>{reserveComf.machiFlg === "1" ? "交換待ち" : reserveComf.machiFlg === "2" ? "キャンセル待ち" : reserveComf.planName}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={inputAcconpanyFlg && reserveComf.machiFlg == 0 ? 'membership_btn_area' : "hiddenItem"}>
                    <Button buttonText="同行者登録" className="membership_top_btn" onClick={() => onClickInputAccompany()} />
                </div>
                <div className='membership_btn_area2'>
                    <Button buttonText="ホテル検索TOPへ戻る" className="membership_top_btn" onClick={() => deleteReserveConf()} />
                </div>
            </div>
            <div className={isWideTablet ? "membership_reserve_footer2" : "membership_reserve_footer"} >
                <MembershipFooterContainer />
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        inputUserInfo: state.inputUserInfo,
        membershipReserveComf: state.membershipReserveComf,
        mealInfoList: state.mealInfoList,
        membershipSearchParam: state.membershipSearchParam,
        membershipReserveInfo: state.membershipReserveInfo
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setOtherMenuInfoList: (item) => {
            dispatch({ type: "OTHER_MENU_INFO_LIST", payload: { otherMenuInfoList: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setInputRoomList: (item) => {
            dispatch({ type: "INPUT_ROOM_LIST", payload: { inputRoomList: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setRight: (item) => {
            dispatch({ type: "RIGHT", payload: { right: item } })
        },
        setMembershipReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_COMF", payload: { membershipReserveComf: item } })
        },
    };
}

const styles = {
    top: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (7.1rem + 100px))",
        height: "100%",
    },
    complete: {
        width: "50px",
        height: "50px",
        backgroundImage: `url(${image_complete})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        margin: "0px auto 10px",
    },
}

export default connect(mapStateToProps, mapToDispatchToProps)(ReserveCompleteContainer);
